import store from '@/features/common/store';
import router from '@/router';

import { getIntegrationsConnectedData } from '@/features/shipment/services/shipment.services';
import { installStoreConnection } from '../services/e-commerce.services';
import { AddStorePayload } from '../types';

export const fetchAndCommitIntegrationConnectedData = async (): Promise<void> => {
  const storesForImport = await getIntegrationsConnectedData();
  store.commit('setStoresForImport', storesForImport);
};

export const redirectToEcommerce = (success?: boolean) => {
  router.push({
    name: 'ecommerce',
    query: { success: success ? 'true' : 'false' },
  });
};

export const handleStoreIntegrationCallback = async (payload: AddStorePayload) => {
  const response = await installStoreConnection(payload);
  redirectToEcommerce(response && response.successful && response.data?.success);
};
